<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
	<div class="md-grey-page portal-page">
		<div class="page-banner"></div>
		<!-- Settings -->
		<section class="portal-page--settings container container-shadow" v-if="!loadingData">
			<div class="portal-page__image-title" v-if="portal.portal_name != ''">
				Upload to {{portal.portal_name}}
			</div>
			<div style="max-width: 500px; margin: 0 auto;">
				<div class="width-100">
					<div class="mdc-switch">
					  <input v-model="portal.active" type="checkbox" class="mdc-switch__native-control" />
					  <div class="mdc-switch__background">
					    <div class="mdc-switch__knob"></div>
					  </div>
					</div>
					<label class="mdc-switch-label">{{portal.active ? 'On' : 'Off'}}</label>
				</div>
				<div class="width-100 mdc-textfield mdc-textfield--upgraded" v-if="!website">
					<input class="mdc-textfield__input" type="text" v-model="portal.portal_name" placeholder="" :class="{'input--valid': portal.name !== ''}">
					<label class="mdc-textfield__label mdc-textfield__label--float-above">Upload Name</label>
				</div>
				<div class="width-100 mdc-textfield mdc-textfield--upgraded">
					<input class="mdc-textfield__input" type="text" v-model="portal.ftp_host" placeholder="" :class="{'input--valid': portal.ftp_host !== ''}">
					<label class="mdc-textfield__label mdc-textfield__label--float-above">FTP Address</label>
				</div>
				<div class="width-100 mdc-textfield mdc-textfield--upgraded">
					<input class="mdc-textfield__input" type="text" v-model="portal.ftp_username" placeholder="" :class="{'input--valid': portal.ftp_username !== ''}">
					<label class="mdc-textfield__label mdc-textfield__label--float-above">FTP Username</label>
				</div>
				<div class="width-100 mdc-textfield mdc-textfield--upgraded">
					<input class="mdc-textfield__input" type="password" v-model="portal.ftp_password" placeholder="" :class="{'input--valid': portal.ftp_password !== ''}">
					<label class="mdc-textfield__label mdc-textfield__label--float-above">FTP Password</label>
				</div>
				<div class="width-100 mdc-textfield mdc-textfield--upgraded">
					<input class="mdc-textfield__input" type="text" v-model="portal.ftp_path" placeholder="" :class="{'input--valid': portal.ftp_path !== ''}">
					<label class="mdc-textfield__label mdc-textfield__label--float-above">FTP Path/Folder</label>
				</div>
				<div class="width-100 mdc-textfield mdc-textfield--upgraded">
					<input class="mdc-textfield__input" type="text" v-model="portal.branch_id_sales" placeholder="" :class="{'input--valid': portal.branch_id_sales !== ''}">
					<label class="mdc-textfield__label mdc-textfield__label--float-above">Branch ID Sales</label>
				</div>
				<div class="width-100 mdc-textfield mdc-textfield--upgraded">
					<input class="mdc-textfield__input" type="text" v-model="portal.branch_id_lettings" placeholder="" :class="{'input--valid': portal.branch_id_lettings !== ''}">
					<label class="mdc-textfield__label mdc-textfield__label--float-above">Branch ID Lettings</label>
				</div>
				<p class="warning-message-portals" v-show="failed">{{ msgerror }} Please review your information!</p>
				<p class="success-message-portals" v-show="saved">Custom portal added successfully</p>
				<button-with-spinner :isSaving="isSaving" :text="isSaving ? 'Saving...' : 'Save'" :customMethod="savePortal" :disabled="isSaving"></button-with-spinner>

				<div class="portal-page__btn-delete" v-if="!website && portal.portalId">
					<a href="#" class="message--error" @click.prevent="deletePortal">Delete this portal</a>
				</div>

				<!-- Back button -->
				<a href="#" class="black-link portal-page__btn portal-page__btn--back" @click.prevent="$router.push('/settings/portals')">&lt; Back</a>
			</div>
		</section>

		<section class="portal-page--settings container container-shadow" v-if="loadingData">
			Loading data. Please wait...
		</section>

	</div>
</template>

<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import api from '@/libs/api.js';
import ButtonWithSpinner  from '../components/ButtonWithSpinner.vue';

export default {
	props: {
		website: {
			type: Boolean,
			default: false
		}
	},
	data: function() {
		return {
			loadingData: true,
			failed: false,
			isSaving: false,
			saved: false,
			msgerror: '',
			portal: {
				active: false,
				portal_name: '',
				website: false,
				ftp_path: '',
				ftp_host: '',
				ftp_username: '',
				ftp_password: '',
				branch_id_sales: '',
				branch_id_lettings: ''
			}
		}
	},
	components: {
		'button-with-spinner': ButtonWithSpinner
	},
	created: async function() {
		var self = this;

		this.portal.website = this.website;
		if(this.portal.website) {
			this.portal.portal_name = 'Website';
		}

		// get portal
		if(this.$route.params.hasOwnProperty('id')) {
			const portalId = this.$route.params.id;
			try {
				this.portal = await api({endpoint: this.config.services.portalsCustom, path: '/' + portalId, method: 'GET'});
			} catch(err) {
				throw {
					type: 'get-portal-custom',
					error: err
				}
			}
		}

		this.loadingData = false;
	},
	methods: {
		savePortal: async function() {
			this.isSaving = true;
			try {
				const response = await api({endpoint: this.config.services.portalsCustom, path: '/', method: 'POST', body: this.portal});
				this.failed = false;
				this.portal.portalId = response.portalId;
				this.saved = true;
			} catch(err) {
				this.failed = true;
				this.isSaving = false;
				this.msgerror = err.response.data.error;
				throw {
					type: 'save-custom-portal',
					error: err
				}
			}
		},

		deletePortal: async function() {
			if(this.portal.portalId && confirm('Are you sure you want to delete this upload?' )) {
				try {
					await api({endpoint: this.config.services.portalsCustom, path: '/' + this.portal.portalId, method: 'DELETE'});

					this.$router.push('/settings/portals');
				} catch(err) {
					throw {
						type: 'delete-custom-portal',
						error: err
					}
				}
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/Settings-Portals-Custom.vue